import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Add your society",
    body:
      "Search your apartment, link your car and parking. We handle the RWA approvals.",
  },
  {
    n: "02",
    title: "Pick a plan",
    body:
      "Standard, Premium, or Luxury. Pause, upgrade, downgrade — no contracts.",
  },
  {
    n: "03",
    title: "Zypper arrives",
    body:
      "Geo-fenced check-in, photo checkpoints before & after. You stay asleep.",
  },
  {
    n: "04",
    title: "Sparkling clean. Done.",
    body:
      "Get a photo receipt and a fresh ride — straight from your parking spot.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-steps"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="text-xs uppercase tracking-[0.22em] text-[#FF5A00] mb-4">
            How it works
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight max-w-3xl mx-auto">
            Four taps from chaos to a calendar-cleaned car.
          </h2>
        </div>

        <div className="relative">
          {/* connecting line */}
          <div className="hidden lg:block absolute top-12 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`how-step-${i}`}
                className="relative"
              >
                <div className="relative h-24 w-24 mx-auto lg:mx-0 mb-6 rounded-full border border-white/10 bg-zinc-950/80 backdrop-blur flex items-center justify-center">
                  <span className="font-heading text-2xl font-medium text-[#FF5A00]">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-heading text-2xl font-medium tracking-tight text-center lg:text-left">
                  {s.title}
                </h3>
                <p className="mt-2 text-zinc-400 text-sm leading-relaxed text-center lg:text-left max-w-[260px] lg:mx-0 mx-auto">
                  {s.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
